export const delay = async (ms: number, func?: () => void) => {
    await new Promise((res) => setTimeout(res, ms));
    if (func) {
        func();
    }
};
